export const API_BASE_URL = import.meta.env.VITE_API_BASE_URL as string;
export const DOCS_BASE_URL = import.meta.env.VITE_DOCS_BASE_URL as string;
export const STRIPE_PUBLISHABLE_KEY = import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY as string;
export const REQUIRES_PASSWORD_TO_REGISTER = import.meta.env.VITE_REQUIRES_PASSWORD_TO_REGISTER as string === "true";
export const ENABLE_SALE_VOLUMES = import.meta.env.VITE_ENABLE_SALE_VOLUMES as string === "true";
export const FREE_TRIAL_PROMO_CODE = import.meta.env.VITE_FREE_TRIAL_PROMO_CODE as string | undefined;
